/** AUTO-GENERATED from shared/security/password_policy.json — do not edit by hand. */

export const PASSWORD_POLICY_VERSION = "e1a1a298ee77" as const;
export const PASSWORD_MAX_LENGTH = 128 as const;
export const PASSWORD_STANDARD_MIN_LENGTH = 8 as const;
export const PASSWORD_SECURE_MIN_LENGTH = 12 as const;
/** Registration / reset flows (secure profile). */
export const PASSWORD_MIN_LENGTH = PASSWORD_SECURE_MIN_LENGTH;
export const PASSWORD_REQUIRED_MESSAGE = "Password is required" as const;

export type PasswordRuleType =
  | "min_length"
  | "max_length"
  | "regex"
  | "regex_forbid"
  | "blocklist_exact";

export interface PasswordRuleSpec {
  id: string;
  type: PasswordRuleType;
  label: string;
  errorMessage: string;
  pattern?: string;
  checklistRequiresInput?: boolean;
}

export const PASSWORD_WEAK_LIST = [
  "password",
  "123456",
  "qwerty",
  "admin",
  "letmein",
  "welcome",
  "monkey",
  "dragon",
  "master",
  "football",
  "baseball",
  "trustno1",
  "god",
  "love",
  "hello",
  "freedom",
  "whatever",
  "qazwsx",
  "test123",
  "user123",
] as const;

export const PASSWORD_RULE_SPECS: PasswordRuleSpec[] = [
  {id: "length", type: "min_length", label: "At least {minLength} characters", errorMessage: "Password must be at least {minLength} characters long"},
  {id: "max_length", type: "max_length", label: "No more than {maxLength} characters", errorMessage: "Password must be no more than {maxLength} characters long", checklistRequiresInput: true},
  {id: "uppercase", type: "regex", label: "One uppercase letter", errorMessage: "Password must contain at least one uppercase letter", pattern: "[A-Z]"},
  {id: "lowercase", type: "regex", label: "One lowercase letter", errorMessage: "Password must contain at least one lowercase letter", pattern: "[a-z]"},
  {id: "digit", type: "regex", label: "One digit", errorMessage: "Password must contain at least one digit", pattern: "\\d"},
  {id: "special", type: "regex", label: "One special character", errorMessage: "Password must contain at least one special character", pattern: "[!@#$%^&*(),.?\":{}|<>_\\-+=~`\\[\\]\\\\/;'`]"},
  {id: "not_weak", type: "blocklist_exact", label: "Not a commonly weak password", errorMessage: "Password contains common weak patterns", checklistRequiresInput: true},
  {id: "no_repeat", type: "regex_forbid", label: "No more than 3 repeated characters in a row", errorMessage: "Password cannot contain more than 3 repeated characters", pattern: "(.)\\1{3,}", checklistRequiresInput: true},
];

export const PASSWORD_CHECKLIST_REQUIRES_INPUT = new Set<string>([
  "max_length",
  "not_weak",
  "no_repeat",
]);
